import { Dropdown, Tooltip } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { FieldMetaDataOption } from 'api/fields';
import { Button } from 'components/atoms/button';
import { Color } from 'components/colors';
import { FieldOption } from '../types';

const colors: Color[] = [
  'red',
  'yellow',
  'green',
  'teal',
  'cyan',
  'blue',
  'purple',
  'magenta',
  'cool-gray',
  'gray',
];

const getRandomInt = (min: number, max: number) => {
  const mn = Math.ceil(min);
  const mx = Math.floor(max);

  return Math.floor(Math.random() * (mx - mn + 1)) + mn;
};

export const getArbitraryColor = (id?: number): Color => {
  const index =
    id != null ? Math.ceil(id) % colors.length : getRandomInt(0, colors.length);

  return colors[index];
};

const OverlayContainer = styled.div`
  background-color: var(--white-100);
  padding: var(--spacing-05);
  box-shadow: var(--shadow-08);
`;

interface Props {
  value?: Color;
  onChange?: (color: string) => void;
  option: FieldOption;
  IconComponent: FC<Pick<FieldMetaDataOption, 'group' | 'color'>>;
  size?: SizeType;
}

export const ColorDropdown: FC<Props> = ({
  value = 'blue',
  onChange,
  option,
  IconComponent,
  size = 'middle',
}) => {
  const { group = { value: -1 }, editable } = option;
  const disabled = !editable;

  return (
    <Dropdown
      disabled={disabled}
      trigger={['click']}
      overlay={
        <OverlayContainer>
          {colors.map((color) => (
            <Button
              size="small"
              key={color}
              type="text"
              icon={<IconComponent group={group.value} color={color} />}
              onClick={() => onChange?.(color)}
            />
          ))}
        </OverlayContainer>
      }
    >
      <Tooltip
        mouseEnterDelay={0.5}
        title={
          disabled ? (
            <FormattedMessage id="settings.fields.change_color.disabled" />
          ) : (
            <FormattedMessage id="settings.fields.change_color" />
          )
        }
      >
        <Button
          size={size}
          type="text"
          disabled={disabled}
          icon={<IconComponent group={group.value} color={value} />}
        />
      </Tooltip>
    </Dropdown>
  );
};
